module.exports = __webpack_public_path__ + "media/images/black_history_month/cook_god_can-a39c5e445d0dc4bc49b2f38cc92de7ed.png";